import { useNavigate } from "react-router-dom";
import { HeaderTitle } from "../../../components/header/Header";
import Container from "../../../components/layout/Container";
import { NavigatePath } from "../../../functions/Navigate.Goback";
import {
  STYLE_MARGIN_TOP_PARENT,
  STYLE_PADDING_MAIN,
  STYLE_TAB,
} from "../../../utils/useStyle";
import React, { useEffect, useState } from "react";
import { Step, Stepper } from "@material-tailwind/react";

import ViewFamily_StepOne from "./ViFamily_StepOne";
import { MTButton } from "../../../components/button/MTButton";
import ViewFamily_StepTwo from "./ViFamily_StepTwo";
import ViewFamily_StepThree from "./ViFamily_StepThree";
import ViewFamily_Final from "./VIFamily_Final";
import { useInsuranceStore } from "../../../_store/insuranceStore";
import { numberWithoutComma } from "../../balance/component/VIDrawerDebt.Main";
import _ from "lodash";
import { defaultValue } from "../../../functions/main";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useEducationStore } from "../../../_store/educationStore";
import { useUserStore } from "../../../_store/userStore";
import {
  calculateRateDifference,
  PV,
  PV2,
  round,
} from "../../../utils/useFunctions";
import {
  sumCapitalInvest,
  sumDebtInvest,
} from "../../../functions/Balance/sumProperty";
import { SumDebtPersonalValue } from "../../../functions/Balance/sumValueBalance";
import { useRetireStore } from "../../../_store/retireStore";
import { PopupMain } from "../../../components/popup/PopupMain";
import {
  calculateFamilyProtectionBase,
  mapFamilyExpensesFromBalance,
} from "../../../functions/insurance/family-expenses";

const Insurance_key = [
  "expenses_insuarant_home",
  "expenses_insuarant_fire",
  "expenses_insuarant_car",
  "expenses_insuarant_accident",
  "expenses_insuarant_life",
];

// โหลดค่าอาหารจาก Balance เพียงครั้งเดียว และใช้ owner กลางคำนวณค่าใช้จ่ายกับ PV จาก input ล่าสุดเพื่อไม่ให้ทุนคุ้มครองช้ากว่า state หนึ่งรอบ
const ViewFamilyInsurance = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);
  const [final, setFinal] = useState(false);
  const [firstLoading, setFirstLoading] = useState(true);
  const [isLastStep, setIsLastStep] = useState(false);
  const [isFirstStep, setIsFirstStep] = useState(false);
  const [openAlert, setOpenAlert] = useState({ expense: false });

  const insuranceData = useInsuranceStore((state) => state.insuranceData);
  const setInsuranceData = useInsuranceStore((state) => state.setInsuranceData);
  const educationData = useEducationStore((state) => state.educationData);
  const balanceData = useBalanceStore((state) => state.balanceData);
  const userData = useUserStore((state) => state.userData);
  const retireData = useRetireStore((state) => state.retireData);

  useEffect(() => {
    // if (!firstLoading) return;
    let localInsuranceData = mapFamilyExpensesFromBalance(
      insuranceData,
      balanceData
    );
    let income_salary = 0;
    let income_bonus = 0;
    let personal_expenses_saving = 0;
    let personal_expenses_tax = 0;
    let personal_expenses_life_fund = 0;
    let personal_expenses_social_insurance = 0;
    let personal_expenses_consumption = 0;
    let personal_expenses_entertainment = 0;
    let personal_expenses_travel = 0;
    let personal_expenses_debt = sumExpensesDebtPerYear();
    let personal_expenses_life_insurance = 0;
    let asset_insurance_private = 0;
    let asset_all = 0;
    let sumInsurancefund = 0;

    balanceData?.expenses_fixed_list
      ?.filter((item) => Insurance_key?.includes(item?.options_expenses_fixed))
      ?.map((item, index) => {
        if (item?.options_expenses_fixed === "expenses_insuarant_home") {
          item?.expenses_insuarant_homes?.map((item2, index2) => {
            sumInsurancefund += Number(item2?.insurance_fund || 0);
          });
        }

        if (item?.options_expenses_fixed === "expenses_insuarant_fire") {
          item?.expenses_insuarant_fires?.map((item2, index2) => {
            sumInsurancefund += Number(item2?.insurance_fund || 0);
          });
        }

        if (item?.options_expenses_fixed === "expenses_insuarant_car") {
          item?.expenses_insuarant_cars?.map((item2, index2) => {
            sumInsurancefund += Number(item2?.insurance_fund || 0);
          });
        }

        if (item?.options_expenses_fixed === "expenses_insuarant_accident") {
          item?.expenses_insuarant_accidents?.map((item2, index2) => {
            sumInsurancefund += Number(item2?.insurance_fund || 0);
          });
        }

        if (item?.options_expenses_fixed === "expenses_insuarant_life") {
          item?.expenses_insuarant_lifes?.map((item2, index2) => {
            sumInsurancefund += Number(item2?.insurance_fund || 0);
          });
        }
      });

    // localInsuranceData.asset_insurance_private = sumInsurancefund;

    if (balanceData?.property_asset_list?.length > 0) {
      asset_all += Number(balanceData?.sum_property_asset || 0);
    }

    if (balanceData?.property_intangible_list?.length > 0) {
      asset_all += Number(balanceData?.sum_property_intangible || 0);
    }

    if (balanceData?.property_invest_list?.length > 0) {
      asset_all +=
        SumDebtPersonalValue(balanceData) +
        sumCapitalInvest(balanceData?.property_invest_list, []) +
        sumDebtInvest(balanceData);
    }

    // if (balanceData?.expenses_fixed_list?.length > 0) {
    //   for (const expenses_fixed_item of balanceData?.expenses_fixed_list) {
    //     if (expenses_fixed_item?.expenses_insuarant_lifes?.length > 0) {
    //       for (const expenses_insuarant_item of expenses_fixed_item?.expenses_insuarant_lifes) {
    //         personal_expenses_life_insurance +=
    //           expenses_insuarant_item.allowance_peryear;
    //         asset_insurance_private += +expenses_insuarant_item?.insurance_fund;
    //       }
    //     }
    //   }
    // }

    if (balanceData?.salary_peryear_list?.length > 0) {
      for (const salary_peryear_item of balanceData?.salary_peryear_list) {
        income_salary += defaultValue(salary_peryear_item?.salary_permonth, 0);
      }
    }

    if (balanceData?.other_income_list?.length > 0) {
      for (const other_income_item of balanceData?.other_income_list) {
        income_bonus += defaultValue(
          other_income_item?.other_income_peryear,
          0
        );
      }
    }

    if (balanceData?.interest_peryear_list?.length > 0) {
      for (const interest_peryear_item of balanceData?.interest_peryear_list) {
        income_bonus += defaultValue(
          interest_peryear_item?.interest_peryear,
          0
        );
      }
    }

    if (balanceData?.expenses_variable_list?.length > 0) {
      for (const expenses_variable_item of balanceData?.expenses_variable_list) {
        if (
          expenses_variable_item.options_expenses_variable === "expenses_tax"
        ) {
          personal_expenses_tax += +expenses_variable_item.pay_peryear;
        }
      }
    }

    if (balanceData?.expenses_fixed_list?.length > 0) {
      for (const expenses_fixed_item of balanceData?.expenses_fixed_list) {
        if (expenses_fixed_item?.expenses_provide_funds?.length > 0) {
          for (const expenses_provide_func_item of expenses_fixed_item.expenses_provide_funds) {
            if (
              expenses_fixed_item.options_expenses_fixed ===
              "expenses_provide_fund"
            ) {
              personal_expenses_life_fund +=
                +expenses_provide_func_item.pay_peryear;
            }
          }
        }
        if (expenses_fixed_item?.expenses_insuarant_socials?.length > 0) {
          for (const expenses_insuarant_socials_item of expenses_fixed_item?.expenses_insuarant_socials) {
            if (
              expenses_fixed_item.options_expenses_fixed ===
              "expenses_insuarant_social"
            ) {
              personal_expenses_social_insurance +=
                +expenses_insuarant_socials_item.pay_peryear;
            }
          }
        }
      }
    }

    if (balanceData?.expenses_variable_list?.length > 0) {
      for (const expenses_variable_item of balanceData?.expenses_variable_list) {
        if (
          expenses_variable_item?.options_expenses_variable ===
          "expenses_consumer"
        ) {
          personal_expenses_consumption += +expenses_variable_item.pay_peryear;
        }
        if (
          expenses_variable_item?.options_expenses_variable ===
          "expenses_recreation"
        ) {
          personal_expenses_entertainment +=
            +expenses_variable_item.pay_peryear;
        }
      }
    }

    if (!+insuranceData?.income_salary) {
      localInsuranceData.income_salary = income_salary;
    }
    if (!+insuranceData?.income_bonus) {
      localInsuranceData.income_bonus = income_bonus;
    }
    if (!+insuranceData?.personal_expenses_saving) {
      localInsuranceData.personal_expenses_saving = personal_expenses_saving;
    }
    if (!+insuranceData?.personal_expenses_tax) {
      localInsuranceData.personal_expenses_tax = personal_expenses_tax;
    }
    if (!+insuranceData?.personal_expenses_life_fund) {
      localInsuranceData.personal_expenses_life_fund =
        personal_expenses_life_fund;
    }
    if (!+insuranceData?.personal_expenses_social_insurance) {
      localInsuranceData.personal_expenses_social_insurance =
        personal_expenses_social_insurance;
    }
    if (!+insuranceData?.personal_expenses_consumption) {
      localInsuranceData.personal_expenses_consumption =
        personal_expenses_consumption;
    }
    if (!+insuranceData?.personal_expenses_entertainment) {
      localInsuranceData.personal_expenses_entertainment =
        personal_expenses_entertainment;
    }
    if (!+insuranceData?.personal_expenses_debt) {
      localInsuranceData.personal_expenses_debt = personal_expenses_debt;
    }
    // if (!+insuranceData?.personal_expenses_life_insurance) {
    //   localInsuranceData.personal_expenses_life_insurance =
    //     personal_expenses_life_insurance;
    // }
    // if (!+insuranceData?.asset_insurance_private) {
    //   localInsuranceData.asset_insurance_private = asset_insurance_private;
    // }

    // balanceData
    //           ?.expenses_fixed_list

    if (balanceData?.expenses_fixed_list?.length > 0) {
      for (const expenses_fixed_item of balanceData?.expenses_fixed_list) {
        if (expenses_fixed_item?.expenses_insuarant_lifes?.length > 0) {
          for (const expenses_insuarant_item of expenses_fixed_item?.expenses_insuarant_lifes) {
            localInsuranceData.asset_insurance_private +=
              +expenses_insuarant_item?.insurance_fund;
          }
        }
      }
    }

    if (!+insuranceData?.personal_expenses_travel) {
      localInsuranceData.personal_expenses_travel = personal_expenses_travel;
    }
    localInsuranceData.asset_all = asset_all;

    // console.log("userData", userData)

    let findMinFamilyAge = userData?.family_tree?.map((item, index) => {
      if (item?.relation?.value === "child") {
        return 25 - item?.age;
      }
      return 100 - item?.age;
    });

    localInsuranceData.family_year_survive =
      findMinFamilyAge?.length > 0 ? Math.max(...findMinFamilyAge) : 20;

    if (userData?.family_tree?.length === 0) {
      localInsuranceData.family_year_survive = 20;
    }

    // if (!+insuranceData?.family_year_survive) {
    //   localInsuranceData.family_year_survive = getFamilyYearSurvive() || 20;
    // }

    if (!+insuranceData?.family_year_survive_max) {
      localInsuranceData.family_year_survive_max = 100;
    }
    localInsuranceData.family_income_rate = retireData?.salary_peryear || insuranceData?.family_income_rate || 3;
    if (!+insuranceData?.family_investment_rate) {
      localInsuranceData.family_investment_rate = 1;
    }

    localInsuranceData.asset_invest_rmf =
      balanceData?.property_invest_list
        ?.find(
          (item) => item.options_property_invest === "property_invest_life"
        )
        ?.invest_life_lists?.reduce((sum, item) => {
          return sum + Number(item?.amount || 0);
        }, 0) || 0;
    setInsuranceData(localInsuranceData);
    setFirstLoading(false);
  }, [balanceData]);

  useEffect(() => {
    if (!firstLoading) {
      onChangeForm("")({
        target: { value: "" },
      });
    }
  }, [firstLoading]);

  const getFamilyYearSurvive = () => {
    let family_year_survive_items = [];

    if (userData?.family_tree?.length > 0) {
      for (const thisFamilyTree of userData?.family_tree) {
        let should_minus = 100;
        let diff_age = 0;
        if (
          thisFamilyTree?.relation?.value === "child" &&
          thisFamilyTree?.age <= 25
        ) {
          should_minus = 25;
        }
        diff_age = should_minus - thisFamilyTree?.age;
        family_year_survive_items.push(diff_age);
      }
    }

    if (family_year_survive_items.length > 0) {
      family_year_survive_items = family_year_survive_items.sort(
        (a, b) => b - a
      );
      return family_year_survive_items[0];
    }
    return 20;
  };

  const onChangeForm =
    (key, type = "number") =>
    (e) => {
      let value = e.target.value;
      if (type === "number") {
        value = numberWithoutComma(value);
      }

      if (_.isNaN(value)) {
        value = "";
      }

      // const newInsurance = key
      //   ? { ...insuranceData, [key]: value }
      //   : { ...insuranceData };

      const newInsurance = { ...insuranceData, [key]: value };

      const keys = Object.keys(newInsurance);
      let sum_family_diff_rate = 0;
      let sum_personal_expenses = 0;
      let sum_income = 0;
      let sum_family = 0;
      let sum_family_survive = 0;
      let sum_family_invest = 0;
      let sum_family_remain = 0;
      let sum_asset = 0;
      let sum_insurance_fund = 0;
      let sum_family_five_year = 0;
      let sum_insurance_education = 0;
      let sum_family_expenses = 0;
      let sum_insurance_net = 0;

      let sum_insurance_current = 0;
      let sum_insurance_more = 0;
      let sum_asset_current = 0;
      let sum_insurance_capital = 0;
      let sum_family_debt = balanceData?.debt_propotion;

      if (educationData?.length > 0) {
        for (const educationItem of educationData) {
          const first_insurance = defaultValue(
            educationItem?.education_items?.[0]?.sum_insurance,
            0
          );
          sum_insurance_education += first_insurance;
        }
      }

      for (const key of keys) {
        if (key.startsWith("personal_expenses")) {
          sum_personal_expenses += defaultValue(+newInsurance[key], 0);
        }
        if (
          key.startsWith("asset") &&
          !["asset_is_social_insurance", "asset_is_debt"].includes(key)
        ) {
          sum_asset += defaultValue(+newInsurance[key], 0);
        }
      }

      if (balanceData?.expenses_fixed_list?.length > 0) {
        for (const expenses_fixed_item of balanceData?.expenses_fixed_list) {
          const keys = Object.keys(expenses_fixed_item);
          for (const key of keys) {
            if (_.isArray(expenses_fixed_item[key])) {
              for (const item_of_key of expenses_fixed_item[key]) {
                sum_insurance_current += +item_of_key.insurance_fund;
              }
            }
          }
        }
      }

      if (
        key === "family_income_rate" &&
        newInsurance[key] > newInsurance.family_income_rate_max
      ) {
        newInsurance[key] = newInsurance.family_income_rate_max;
      }
      if (
        key === "family_investment_rate" &&
        newInsurance[key] > newInsurance.family_investment_rate_max
      ) {
        newInsurance[key] = newInsurance.family_investment_rate_max;
      }

      newInsurance.income_salary_per_year =
        defaultValue(newInsurance.income_salary, 0) * 12;
      sum_family_diff_rate = calculateRateDifference(
        newInsurance.family_investment_rate,
        newInsurance.family_income_rate
      );

      sum_income = defaultValue(newInsurance.income_salary_per_year, 0);
      // +
      // defaultValue(newInsurance.income_bonus, 0);
      const familyProtectionBase = calculateFamilyProtectionBase({
        insuranceData: newInsurance,
        balanceData,
        sumIncome: sum_income,
        rateDifference: sum_family_diff_rate,
        familyYearSurvive: newInsurance?.family_year_survive,
        calculatePresentValue: PV,
      });
      sum_family_expenses = familyProtectionBase.sumFamilyExpenses;
      sum_family = familyProtectionBase.sumFamily;

      sum_family_five_year = sum_family_expenses * 5;

      sum_family_survive =
        sum_family *
        (1 + defaultValue(newInsurance.family_income_rate, 0) / 100) **
          newInsurance.family_year_survive;

      sum_family_invest =
        sum_family *
        (1 + defaultValue(newInsurance.family_investment_rate, 0) / 100) **
          newInsurance.family_year_survive;

      if (
        newInsurance.family_investment_rate > newInsurance.family_income_rate
      ) {
        sum_family_remain = sum_family_survive;
      } else {
        sum_family_remain =
          sum_family_survive + (sum_family_survive - sum_family_invest);
      }

      sum_insurance_current =
        numberWithoutComma(sum_insurance_current) +
        numberWithoutComma(newInsurance.asset_insurance_private) +
        numberWithoutComma(newInsurance.asset_insurance_group) +
        numberWithoutComma(newInsurance.asset_invest_rmf);

      sum_asset_current = Math.abs(Number(newInsurance.asset_all || 0));

      if (newInsurance.asset_is_social_insurance === "Y") {
        newInsurance.asset_social_dead_contribution = 75000;
        newInsurance.asset_social_dead = 40000;

        sum_asset_current =
          Math.abs(Number(newInsurance.asset_social_retire) || 0) +
          Math.abs(Number(newInsurance.asset_social_dead) || 0) +
          Math.abs(Number(newInsurance.asset_social_dead_contribution) || 0);
      } else {
        newInsurance.asset_social_retire = 0;
        newInsurance.asset_social_dead = 0;
        newInsurance.asset_social_dead_contribution = 0;
      }

      // sum_family_remain = sum_family;
      // sum_family_survive = sum_family;
      sum_insurance_fund = sum_family_remain - sum_asset;

      // sum_family_five_year = sum_family_expenses * 5;

      if (newInsurance?.asset_is_debt === "N") {
        sum_insurance_education = 0;
        sum_family_debt = 0;
      }
      sum_insurance_net =
        // sum_family_remain + sum_insurance_education + sum_family_debt;
        sum_family + sum_insurance_education + sum_family_debt;
      sum_insurance_more = sum_insurance_net - sum_asset;
      // sum_insurance_net - sum_insurance_current - sum_asset_current;
      sum_insurance_capital = round(Math.abs(sum_family) - sum_asset, 0);

      setInsuranceData({
        ...newInsurance,
        sum_insurance_capital,
        sum_family_diff_rate,
        sum_family_debt,
        sum_personal_expenses,
        sum_income,
        sum_family,
        sum_family_survive,
        sum_family_invest,
        sum_family_remain,
        sum_asset,
        sum_insurance_fund,
        sum_family_five_year,
        sum_insurance_education,
        sum_family_expenses,
        sum_insurance_net,
        sum_insurance_current,
        sum_insurance_more,
        sum_asset_current,
      });
    };

  // หายอดรวมค่าใช้จ่ายหนี้สินรายเดือนทั้งหมด
  const sumExpensesDebtPerMonth = () => {
    let result = 0;
    if (balanceData?.sum_debt_short_permonth) {
      result += balanceData?.sum_debt_short_permonth;
    }
    if (balanceData?.sum_debt_long_permonth) {
      result += balanceData?.sum_debt_long_permonth;
    }
    return result;
  };

  // หายอดรวมค่าใช้จ่ายหนี้สินรายปีทั้งหมด
  const sumExpensesDebtPerYear = () => {
    let result = 0;
    result = sumExpensesDebtPerMonth() * 12;
    return round(result, 0);
  };

  return (
    <div>
      {/* <PopupMain
        open={openAlert.expense}
        title={"กรุณาเช็คข้อมูลรายรับและค่าใช้จ่าย"}
        text={`รายรับต้องมากกว่าค่าใช้จ่าย`}
        onClick={() => {
          setOpenAlert({ ...openAlert, expense: false });
        }}
      /> */}
      <Container>
        <div className=" mb-10">
          <div className={`${STYLE_MARGIN_TOP_PARENT} `}>
            <HeaderTitle
              title="ทุนประกันคุ้มครองเพื่อครอบครัว"
              isGoback
              onClickGoBack={() => {
                if (final) {
                  setFinal(false);
                  setTab(2);
                  return;
                }
                navigate(-1);
              }}
            />
            {final ? (
              <ViewFamily_Final
                setFinal={setFinal}
                setTab={setTab}
                insuranceData={insuranceData}
              />
            ) : (
              <>
                <div className={` ${STYLE_PADDING_MAIN}`}>
                  {/* ------ หัวข้อ Step ------ */}
                  <div className=" px-4">
                    <Stepper
                      activeStep={tab}
                      lineClassName="bg-gray-300"
                      activeLineClassName="bg-maincyan"
                      className={`${STYLE_TAB} `}
                      isLastStep={(value) => setIsLastStep(value)}
                      isFirstStep={(value) => setIsFirstStep(value)}
                    >
                      <Step
                        className=" !bg-maincyan text-lg"
                        activeClassName="!bg-maincyan "
                        onClick={() => setTab(0)}
                      >
                        <div className=" mt-0.5">1</div>
                      </Step>
                      <Step
                        onClick={() => setTab(1)}
                        className={`${
                          tab === 0 ? "!bg-gray300" : "!bg-maincyan"
                        }`}
                        activeClassName="!bg-maincyan"
                      >
                        <div className=" mt-0.5">2</div>
                      </Step>

                      <Step
                        className="!bg-gray-300"
                        activeClassName="!bg-maincyan"
                        onClick={() => setTab(2)}
                      >
                        <div className=" mt-0.5">3</div>
                      </Step>
                    </Stepper>
                  </div>
                </div>
                {tab === 0 && (
                  <ViewFamily_StepOne
                    onChangeForm={onChangeForm}
                    insuranceData={insuranceData}
                  />
                )}
                {tab === 1 && (
                  <ViewFamily_StepTwo
                    onChangeForm={onChangeForm}
                    insuranceData={insuranceData}
                  />
                )}
                {tab === 2 && (
                  <ViewFamily_StepThree
                    onChangeForm={onChangeForm}
                    insuranceData={insuranceData}
                    balanceData={balanceData}
                  />
                )}
                <div className=" flex justify-center gap-4 mb-10 px-5">
                  {tab === 0 ? (
                    <div>
                      <MTButton
                        // loading={loading}
                        text={"ถัดไป"}
                        color="bg-maincyan"
                        onClick={(e) => {
                          setTab((prev) => prev + 1);
                        }}
                      />
                    </div>
                  ) : tab === 1 ? (
                    <div>
                      <MTButton
                        // loading={loading}
                        text={"ถัดไป"}
                        color="bg-maincyan"
                        onClick={(e) => {
                          // if (
                          //   defaultValue(insuranceData?.sum_income) -
                          //     defaultValue(
                          //       insuranceData?.sum_personal_expenses
                          //     ) <
                          //   0 || defaultValue(insuranceData?.sum_family, 0) < 0
                          // ) {
                          //   // alert("รายรับต้องมากกว่าค่าใช้จ่าย");
                          //   setOpenAlert({ ...openAlert, expense: true });

                          //   return;
                          // }
                          setTab((prev) => prev + 1);
                        }}
                      />
                    </div>
                  ) : (
                    <div>
                      {tab === 3 ? (
                        ""
                      ) : (
                        <div className=" flex justify-center items-center gap-2">
                          <MTButton
                            // loading={loading}
                            text="ย้อนกลับ"
                            color="border border-maincyan "
                            colortext="text-maincyan group-hover:text-white"
                            hovercolor="hover:bg-maincyan group "
                            onClick={() => {
                              setTab((prev) => prev - 1);
                            }}
                          />
                          <MTButton
                            // loading={loading}
                            text={"ถัดไป"}
                            color="bg-maincyan"
                            onClick={(e) => {
                              if (tab === 2) {
                                setFinal(true);
                                setInsuranceData({
                                  ...insuranceData,
                                  is_plan: true,
                                });
                                return;
                              }
                              setTab((prev) => prev + 1);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ViewFamilyInsurance;
